import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {MoveSecuritiesUsageReviewDialogComponent} from "@irb/irb-editors/editor-security/move-securities-usage-review-dialog/move-securities-usage-review-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class MoveSecuritiesUsageReviewDialogGridLayoutService implements GridLayoutService<MoveSecuritiesUsageReviewDialogComponent> {
    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Security',
            field: 'securitySymb',
            maxWidth: 130,
            width: 130,
            cellRenderer: 'cellRendererFormatter',
            sort: 'asc'
        },
            {
                headerName: 'Will no longer be',
                field: 'relatedAs',
                maxWidth: 250,
                width: 250,
                cellRenderer: 'cellRendererFormatter'
            },
            {
                headerName: 'For this OTHER Security/portfolio',
                field: 'relatedToNameAndDescription',
                maxWidth: 220,
                width: 200,
                cellRenderer: 'cellRendererFormatter'
            }];
    }
}
